module.exports = __webpack_public_path__ + "static/media/cool-emoji-svgrepo-com (1).11fb8ebd.svg";